import { useEffect } from 'react'
import { useDocuments } from '../api'
import { useFilters } from './use-filters'
import { usePaginationSelectors } from './use-pagination-store'

export const usePaginatedDocuments = () => {
  const { data } = useDocuments()
  const { filters } = useFilters()
  const { currentPage, evaluationKeysMap, setEvaluationKeysMap, setVisibleRowsCount } =
    usePaginationSelectors({ pageSize: filters.pageSize })

  useEffect(() => {
    if (data.last_evaluated_key && !evaluationKeysMap[currentPage + 1]) {
      setEvaluationKeysMap({
        ...evaluationKeysMap,
        [currentPage + 1]: data.last_evaluated_key,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.last_evaluated_key])

  useEffect(() => {
    setVisibleRowsCount(data.items.length)
  }, [data.items, setVisibleRowsCount])

  return { data }
}
